import {
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoMaterialOutlinedInput,
    RaikoNumberInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    RaikoToggleOutlined, showErrorMessage, showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components"
import {useEffect, useState} from "react";
import RaikoApkSelector from "./apkSelector/RaikoApkSelector";
import {css} from "@emotion/css";
import {stringIsEmpty} from "../../util/VariableChecker";
import {VersionControlService} from "../../serverService/versionControl/VersionControlService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function VersionControlAddDetail({versionControlId, handleAddNewVersion, handleUpdateVersion}) {

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [apkId, setApkId] = useState(-1);
    const [apkFile, setApkFile] = useState(null);
    const [apkFileName, setApkFileName] = useState("");
    const [apkLink, setApkLink] = useState();
    const [apkName, setApkName] = useState();

    const [name, setName] = useState("");
    const [versionCode, setVersionCode] = useState("");
    const [minimumCode, setMinimumCode] = useState("")
    const [enabled, setEnabled] = useState(false);
    const [updateType, setUpdateType] = useState(false);
    const [description, setDescription] = useState("")

    const [showLoadingProgress, setShowLoadingProgress] = useState(false);
    const [progress, setProgress] = useState(0);

    const versionControlService = new VersionControlService()

    useEffect(() => {
        if (versionControlId && versionControlId > 0)
            getDetailFromServer()
    }, [versionControlId]);

    function getDetailFromServer() {
        loading.show()
        versionControlService.getVersionDetail(versionControlId)
            .then(response => {
                setName(response.title)
                setDescription(response.description)
                setEnabled(response.enabled)
                setUpdateType(response.mandatory)
                setVersionCode(response.versionNumber)
                setMinimumCode(response.latestVersionForMandatoryUpdate)

                if (response.apkFile) {
                    setApkId(response.apkFile.id)
                    setApkLink(response.apkFile.url)
                    setApkName(response.apkFile.name)
                }

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleAddNewApk() {
        if (checkFields()) {
            loading.show()
            if (versionControlId === -1) {
                versionControlService
                    .createNewVersion(
                        apkFile,
                        name,
                        versionCode,
                        minimumCode,
                        enabled,
                        updateType,
                        description,
                        setProgress,
                        setShowLoadingProgress
                    ).then(response => {
                    showSuccessMessage("نسخه جدید با موفقیت افزوده شده.")
                    handleAddNewVersion(response)
                }).catch(reason => {
                    showErrorMessage(detectServerErrorMessage(reason))
                    setShowLoadingProgress(false)
                }).finally(_ => {
                    loading.hide()
                })
            } else {
                versionControlService
                    .updateVersion(
                        versionControlId,
                        apkId,
                        apkFile,
                        name,
                        versionCode,
                        minimumCode,
                        enabled,
                        updateType,
                        description,
                        setProgress,
                        setShowLoadingProgress
                    ).then(response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                    handleUpdateVersion(response)
                }).catch(reason => {
                    showErrorMessage(detectServerErrorMessage(reason))
                    setShowLoadingProgress(false)
                }).finally(_ => {
                    loading.hide()
                })
            }
        }
    }

    function checkFields() {
        let state = false
        let message

        if (!apkFile && apkId === -1)
            message = "لطفا فایل apk مورد نظر خود را انتخاب نمایید."
        else if (stringIsEmpty(name))
            message = "لطفا نام نسخه را وارد نمایید."
        else if (stringIsEmpty(versionCode))
            message = "لطفا ورژن نسخه را وارد نمایید."
        else if (stringIsEmpty(minimumCode))
            message = "لطفا حداقل ورژن مجاز نسخه را وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>

            <RaikoApkSelector
                apkFile={apkFile}
                setApkFile={setApkFile}
                apkFileName={apkFileName}
                setApkFileName={setApkFileName}
                uploadPercent={progress}
                showUploadLoading={showLoadingProgress}
                uploadedApkUrl={apkLink}
                uploadedApkName={apkName}
            />
            <RaikoGridThreeColumn>
                <RaikoMaterialOutlinedInput labelText={"نام نسخه"} value={name} setValue={setName}/>
                <RaikoNumberInputOutlined labelText={"ورژن"} value={versionCode} setValue={setVersionCode}/>
                <RaikoNumberInputOutlined labelText={"حداقل ورژن مجاز"} value={minimumCode} setValue={setMinimumCode}/>
                <RaikoToggleOutlined
                    checked={enabled}
                    setChecked={setEnabled}
                    labelText={"وضعیت(فعال/غیرفعال)"}
                />

                <RaikoToggleOutlined
                    checked={updateType}
                    setChecked={setUpdateType}
                    labelText={"بروزرسانی(احباری/اختیاری)"}
                />

            </RaikoGridThreeColumn>
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات"}
                value={description}
                setValue={setDescription}
            />
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={versionControlId === -1 ? "افزودن" : "بروزرسانی"} onClick={handleAddNewApk}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}